/**
 * 帳號權限判定（無 Vue／localStorage 依賴，供 authService 與 usePermissions 共用）
 */

import { isClientOwner } from '../../utils/clientAccount.js';

export function isAllPermissionsFlag(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/**
 * @param {Object|null} user
 * @param {string} permission
 * @returns {boolean}
 */
export function accountHasPermission(user, permission) {
  if (!user) return false;

  if (isClientOwner(user)) {
    return true;
  }

  if (isAllPermissionsFlag(user.hasAllPermissions)) {
    return true;
  }

  const permissions = user.permissions || [];
  return permissions.includes(permission) || permissions.includes('*');
}
